function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".chat_svg__c,.chat_svg__e{fill:#fff}.chat_svg__c,.chat_svg__h{stroke:#1d1f2c}.chat_svg__c,.chat_svg__e,.chat_svg__g,.chat_svg__h{stroke-width:2px}.chat_svg__e,.chat_svg__g{stroke:#d32f2f}.chat_svg__e,.chat_svg__g,.chat_svg__h{stroke-linecap:round}.chat_svg__e{stroke-linejoin:round}.chat_svg__g,.chat_svg__h,.chat_svg__j{fill:none}.chat_svg__i{stroke:none}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.739 68.596a22.994 22.994 0 010-32.525L35.313 8.497A23 23 0 1167.84 41.022L40.264 68.596a22.994 22.994 0 01-32.525 0z",
  fill: "#ffd5d5"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "chat_svg__c",
  transform: "translate(17 6)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "chat_svg__i",
  width: 40,
  height: 68,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  className: "chat_svg__j",
  x: 1,
  y: 1,
  width: 38,
  height: 66,
  rx: 4
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.512 35.35a15.114 15.114 0 01-15.113 15.113c-.4 0-.779-.012-1.163-.047a15.105 15.105 0 010-30.122 9.613 9.613 0 011.163-.058A15.114 15.114 0 0133.512 35.35z",
  stroke: "#d32f2f",
  strokeWidth: 2,
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "chat_svg__c",
  d: "M40.517 65.223a1.517 1.517 0 110 3.033h-7.033a1.517 1.517 0 110-3.033z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "chat_svg__e",
  d: "M53.517 48.742L38.16 42.16a2.3 2.3 0 000-1.551l15.357-6.582a2.3 2.3 0 011.84 0l1.408.607 13.949 5.975a2.3 2.3 0 000 1.551l-13.949 5.98-1.408.6a2.276 2.276 0 01-.918.191 2.3 2.3 0 01-.922-.189z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "chat_svg__c",
  transform: "translate(43 33)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "chat_svg__i",
  width: 23,
  height: 21,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  className: "chat_svg__j",
  x: 1,
  y: 1,
  width: 21,
  height: 19,
  rx: 3
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "chat_svg__e",
  d: "M70.714 41.162v16.276a2.332 2.332 0 01-2.325 2.324h-27.9a2.332 2.332 0 01-2.327-2.324V41.162l15.358 6.58a2.3 2.3 0 001.837 0l1.407-.6z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M57.981 40.632a1 1 0 010 1.736L54 44.645a1 1 0 01-1.5-.868v-4.554a1 1 0 011.5-.868z",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 2,
  stroke: "#1d1f2c",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "chat_svg__e",
  d: "M16.909 45.271a2.334 2.334 0 01-.521-2.943H13.88a2.41 2.41 0 01-2.414-1.932 2.315 2.315 0 011.232-2.465 2.1 2.1 0 001.057-1.881v-3.027a4.645 4.645 0 012.635-4.189 2.5 2.5 0 114.18.076 4.646 4.646 0 012.486 4.113v3.131a2.145 2.145 0 001.164 1.834 2.31 2.31 0 011.125 2.408c-.187 1.137-1.256 1.932-3.1 1.932h-1.826a2.325 2.325 0 01-3.508 2.943z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "chat_svg__g",
  d: "M38 19.758h12.191M38 23.758h12.191M48.16 27.758h2.033M38 27.758h6.572"
});

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "chat_svg__h",
  d: "M31.297 10.758h-.3M43.194 10.758h-8.969"
}));

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default "data:image/svg+xml;base64,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";
export { SvgChat as ReactComponent };